import { Text } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';
import { EclipsePackagePickerModule } from '../../../modules/eclipse-package-picker.module';
import s from './ProductCard.scss';
import { CURRENT_PLAN_TAB_HEIGHT } from './useCurrentPlanTab';

export const CurrentPlanTab = ({ isOutlined }: { isOutlined: boolean }) => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();

  return (
    <div
      className={classNames(s.currentPlanTab, {
        [s.currentPlanTabOutlined]: isOutlined,
      })}
      style={{ height: CURRENT_PLAN_TAB_HEIGHT }}
      data-hook="current-plan-tab"
    >
      <Text size="small" weight="bold" className={s.currentPlanTabText}>
        {t('premium-purchase-plan.eclipse.cards.hat.current.plan')}
      </Text>
    </div>
  );
};
